import {
  AirPriceFreezePurchaseState,
  type AirPriceFreezeMachineContext,
  getPriceFreezeOfferMachine,
  GenericChildState,
  getCartQuoteMachine,
  getCartFulfillMachine,
} from "@hopper-b2b/checkout";
import type { MachineConfig } from "xstate";
import {
  type UberPaymentContext,
  getUberPaymentMachine,
} from "../../checkout/states/payments";
import { Event, type TEvent } from "./events";

import { getInitialPriceFreezeMachineContext } from "./initialContext";
import { ServiceTypes } from "./services";

export const airPriceFreezePurchaseMachineId = "air-price-freeze-purchase";

export const priceFreezePurchaseStateMachine: MachineConfig<
  AirPriceFreezeMachineContext<UberPaymentContext>,
  any,
  TEvent
> = {
  schema: {
    context: getInitialPriceFreezeMachineContext(),
    events: {} as TEvent,
  },

  // Machine identifier
  id: airPriceFreezePurchaseMachineId,

  // Initial state
  initial: AirPriceFreezePurchaseState.priceFreezeOffer,

  // State definitions
  states: {
    [AirPriceFreezePurchaseState.priceFreezeOffer]: {
      ...getPriceFreezeOfferMachine({
        parentMachineId: airPriceFreezePurchaseMachineId,
        nextState: `#${airPriceFreezePurchaseMachineId}.${AirPriceFreezePurchaseState.cartQuote}`,
      }),
    },
    [AirPriceFreezePurchaseState.cartQuote]: {
      ...getCartQuoteMachine({
        parentMachineId: airPriceFreezePurchaseMachineId,
        nextState: `#${airPriceFreezePurchaseMachineId}.${AirPriceFreezePurchaseState.payment}`,
      }),
    },
    [AirPriceFreezePurchaseState.payment]: {
      initial: GenericChildState.loading,
      states: {
        [GenericChildState.loading]: {
          invoke: {
            src: ServiceTypes.trackUberPaymentPf,
            onDone: `#${airPriceFreezePurchaseMachineId}.${AirPriceFreezePurchaseState.payment}.${GenericChildState.idle}`,
            onError: `#${airPriceFreezePurchaseMachineId}.${AirPriceFreezePurchaseState.payment}.${GenericChildState.idle}`,
          },
        },
        [GenericChildState.idle]: {},
      },
      ...getUberPaymentMachine({
        parentMachineId: airPriceFreezePurchaseMachineId,
        previousState: `#${airPriceFreezePurchaseMachineId}.${AirPriceFreezePurchaseState.priceFreezeOffer}`,
        nextState: `#${airPriceFreezePurchaseMachineId}.${AirPriceFreezePurchaseState.cartFulfill}`,
      }),
    },
    [AirPriceFreezePurchaseState.cartFulfill]: {
      ...getCartFulfillMachine({
        parentMachineId: airPriceFreezePurchaseMachineId,
        nextState: `#${airPriceFreezePurchaseMachineId}.${AirPriceFreezePurchaseState.confirmation}`,
        failedState: `#${airPriceFreezePurchaseMachineId}.${AirPriceFreezePurchaseState.fulfillFailed}`,
      }),
    },
    [AirPriceFreezePurchaseState.fulfillFailed]: {},
    [AirPriceFreezePurchaseState.confirmation]: {},
  },
  on: {
    [Event.GO_TO_PRICE_FREEZE_OFFER]: `#${airPriceFreezePurchaseMachineId}.${AirPriceFreezePurchaseState.priceFreezeOffer}`,
    [Event.GO_TO_PAYMENT]: `#${airPriceFreezePurchaseMachineId}.${AirPriceFreezePurchaseState.payment}`,
    [Event.GO_TO_PRICE_FREEZE_CONFIRMATION]: `#${airPriceFreezePurchaseMachineId}.${AirPriceFreezePurchaseState.confirmation}`,
    [Event.GO_TO_FULLFILL]: `#${airPriceFreezePurchaseMachineId}.${AirPriceFreezePurchaseState.cartFulfill}`,
    [Event.GO_TO_FULLFILL_FAILED]: `#${airPriceFreezePurchaseMachineId}.${AirPriceFreezePurchaseState.fulfillFailed}`,
  },
};
